import RestApi from '@utilities/RestApi'
import Axios from 'axios'

import { refreshTokenInterceptor } from '@services/APIInterceptors/refreshTokenInterceptors'

class NotificationsSingleton {
  constructor() {
    const httpConfig = {
      baseURL: import.meta.env.VITE_REACT_APP_URL_NOTIFICATION,
      headers: {
        'Content-Type': 'application/json',
      },
    }

    this.client = Axios.create(httpConfig)
    console.info(`Axios instance NOTIFICATIONS: ${this.client.defaults.baseURL}`)

    this.client.interceptors.request.use(refreshTokenInterceptor)

    //v2 requests api
    this.events = new RestApi(this.client, '/api/v3/events')
  }

  static get instance() {
    return this._instance || (this._instance = new this())
  }

  updateHeaders(headerLines) {
    this.client.defaults.headers.common = {
      ...this.client.defaults.headers.common,
      ...headerLines,
    }
  }

  // sets the default headers
  removeHeaders() {
    this.client.defaults.headers.common = {
      Accept: 'application/json',
    }
  }
}

const Notifications = NotificationsSingleton.instance
export default Notifications
